import React from "react";

// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";

import SimpleInput from "components/SimpleInput/SimpleInput.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  ...customSelectStyle
};

const addressFields = [
      {name:"addressStreet1",label:"Street 1",size:12},
      {name:"addressStreet2",label:"Street 2",size:12},
      {name:"addressCity",label:"City",size:6},
      {name:"addressProvince",label:"Province",size:2},
      {name:"addressPostalCode",label:"Postal Code",size:4},
      {name:"addressCountry",label:"Country",size:12},
      {name:"contactMobile",label:"Mobile",size:12},
      {name:"contactEmail",label:"Email",size:12},
    ];


class Step2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      city: "",
      country: "",
    };
  }
  change = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  isValidated() {
    return true;
  }
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center">
        <ItemGrid xs={12} sm={12}>
          <h4 className={classes.infoText}>Are you living in a nice area?</h4>
        </ItemGrid>


        {addressFields.map((prop,key)=>{
        return (
          <SimpleInput key={key} type={prop.type}  name={prop.name} label={prop.label} classes={classes} size={prop.size} handler={this.change} />
        )})}


      </GridContainer>
    );
  }
}

export default withStyles(style)(Step2);



// WEBPACK FOOTER //
// ./src/views/Receiver/AddLocationWizardSteps/Step2.jsx